import styled from 'styled-components';

import {commonPalette} from '../../styles/palette';
import {cornerRadius} from '../../styles/vars';
import {inputMetrics} from '../../styles/metrics';
import {textStyles} from '../../styles/typefaces';

export const Input = styled.input`
  ${textStyles.desktop.generalBody}
  height: ${inputMetrics.height}px;
  padding: 0 12px;
  color: ${commonPalette.textPrimary};
  background: ${commonPalette.surfaceDefault};
  border: 1px solid ${commonPalette.strokeDefault};
  border-radius: ${cornerRadius.default}px;
  outline: none;

  ::placeholder {
    color: ${commonPalette.textSecondary};
  }

  &:focus-visible {
    box-shadow: ${commonPalette.focusShadow};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
